import React from "react";
import {useMsal} from "@azure/msal-react";
import {loginRequest} from "../../../authConfig";
import styled from "styled-components";
import {Button} from "../../buttons/ButtonStyles";
import {useDispatch} from "react-redux";
import {azureLogin} from "../../auth/actions/authAction";
import {useNavigate} from "react-router-dom";
import microsoftLogo from '../../../images/logo_microsoft.svg'


/**
 * Renders a button which open a popup for login
 */
export const SignInButton = ({setAzureError}) => {
    const { instance } = useMsal();
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const handleLogin = async (loginType) => {
        if (loginType === "popup") {
            await instance.loginPopup(loginRequest).catch(e => {
            });
       let secretIndex = -1
            for (let i = 0; i < sessionStorage.length; i++) {
                if(JSON.parse(sessionStorage.getItem(sessionStorage.key(i)))['credentialType'] === 'IdToken')
                    secretIndex = i
            }
            if(JSON.parse(sessionStorage.getItem(sessionStorage.key(secretIndex))) !== null ){
                let token = JSON.parse(sessionStorage.getItem(sessionStorage.key(secretIndex))).secret
                dispatch(azureLogin(token))
                navigate(1)
            }
            else{
                setAzureError("Une erreur est survenue. Veuillez contacter votre ambassadeur Enjoy.")
            }

        }
    }
    return (
            <Btn className='btn-login'  onClick={(e) => {
                e.preventDefault();
                handleLogin("popup")}}>
                <Title>
                    <img src={microsoftLogo} alt="Microsoft"/>
                    <h5>Connexion Microsoft</h5>
                </Title>
            </Btn>
    );
}

const Btn = styled(Button)`
  border: 2px solid white;
  background-color: transparent;
  align-self: center;
  width: 100%;
  max-width: 450px;
  height: 2.5rem;
  &:hover{
    background: var(--color-white);
    h5{
      color:  var(--color-purple);
    }
  }
  @media screen and (min-width: 900px) {
    width: 80%;
  }
  @media screen and (min-width: 1200px) {
    font-size: 16px;
  }
`
const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 1rem;
  gap: 0.8rem;
  img{
    max-width: 1.3rem;
    max-height: 1.3rem;
  }
  h5{
    color: var(--color-white);
  }
`